<app-stages [stages]='stages' currentStage='Zajęcia'></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-12">
        <app-road-occupation-form
          [serviceId]="serviceType()?.uuid || null"
          [workPurposeControlType]="workPurposeControlType"
          [purposeControlType]="purposeControlType"
          [form]='form'>
        </app-road-occupation-form>
      </div>
    </div>
    <div class='form-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        [disabled]='pending()'
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
  <br>
}
@if (pending()) {
  <app-spinner>
    Poczekaj trwa zapisywania danych...
  </app-spinner>
}
@if (loading()) {
  <app-spinner>
    Poczekaj trwa ładowanie danych...
  </app-spinner>
}
